import type { Reservation } from "@b2bportal/ground-api";

/**
 * Returns the user-facing car confirmation code.
 * Always prefer the supplier booking ID (what the user gives at the counter),
 * falling back to the provider booking ID. Never use reservationId.
 */
export const getCarConfirmationCode = (
  reservation: Reservation
): string | undefined =>
  reservation.confirmationInfo?.supplierBookingId ??
  reservation.confirmationInfo?.providerBookingId;
